export default __webpack_public_path__ + "static/bg_header_evening-cd095087101d4057d10c6f8c032a39e6.svg";